export default __webpack_public_path__ + "static/media/canary_wharf_station.23facdec.jpg";